import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Chip, Container, Grid, Stack, Typography } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import PlatformMockup from "@/pages/landing/PlatformMockup";

function scrollToPreview() {
  document.getElementById("platform-preview")?.scrollIntoView({ behavior: "smooth" });
}

export function HeroSection() {
  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #0F3D63 0%, #1976D2 100%)",
        pt: { xs: 10, md: 14 },
        pb: { xs: 10, md: 16 },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Chip
              icon={<AutoAwesomeIcon sx={{ color: "#93C5FD !important" }} />}
              label="AI-Powered Investment Intelligence"
              size="small"
              sx={{
                mb: 3,
                bgcolor: "rgba(255,255,255,0.1)",
                color: "#BFDBFE",
                border: "1px solid rgba(255,255,255,0.2)",
                fontWeight: 600,
              }}
            />

            <Typography
              variant="h2"
              fontWeight={800}
              color="#fff"
              sx={{ fontSize: { xs: "2.25rem", md: "3rem" }, lineHeight: 1.15, mb: 3 }}
            >
              AI-Powered Investment Intelligence Platform
            </Typography>

            <Typography variant="h6" sx={{ color: "rgba(255,255,255,0.82)", fontWeight: 400, mb: 5, maxWidth: 520 }}>
              Analyze markets with AI-driven insights, build smarter portfolios, deploy algorithmic
              trading strategies, and connect the broker accounts you already use — all from one
              secure platform.
            </Typography>

            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <Button
                component={RouterLink}
                to="/register"
                variant="contained"
                size="large"
                sx={{ bgcolor: "#fff", color: "primary.main", px: 4, "&:hover": { bgcolor: "#EFF6FF" } }}
              >
                Create Free Account
              </Button>
              <Button
                onClick={scrollToPreview}
                variant="outlined"
                size="large"
                startIcon={<PlayCircleOutlineIcon />}
                sx={{
                  color: "#fff",
                  borderColor: "rgba(255,255,255,0.4)",
                  px: 4,
                  "&:hover": { borderColor: "#fff", bgcolor: "rgba(255,255,255,0.06)" },
                }}
              >
                Watch Demo
              </Button>
            </Stack>

            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.72)", mt: 4 }}>
              Not a broker — TekStar Invest connects securely to your existing broker account.
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ maxWidth: 460, mx: { xs: "auto", md: 0 } }}>
              <PlatformMockup variant="dashboard" />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default HeroSection;
